<template>
    <div>
        <CultivationOfTalentsTop />
        <div class="titleStyle">
            <div class="titleFont">培训体系</div>
            <div class="conentFont">
                <div class="divide"></div>
                <span class="enFont">EMPLOYEE TRAINING</span>
                <div class="divide"></div>
            </div>
        </div>
        <div class="middle">
            <div
                class="middleItem"
                v-for="(item, idx) in topList"
                :key="idx"
                v-show="idx < 2"
                @click="findDetail(item)"
            >
                <div class="itemImg">
                    <img :src="item.image" style="width:100%;height:100%;">
                </div>
                <div class="itemTitle">{{ item.title }}</div>
                <div class="itemContent">
                    {{ item.description }}
                </div>
            </div>
        </div>
        <div class="carouselDiv">
            <img
                src="@/assets/CultivationOfTalents/left.png"
                class="carouselDivLeft"
                @click="leftClick"
                v-show="infoList.length > 1"
            />
            <img
                src="@/assets/CultivationOfTalents/right.png"
                class="carouselDivRight"
                @click="rightClick"
                v-show="infoList.length > 1"
            />
            <a-carousel ref="carouselDom">
                <div v-for="(item, idx) in infoList" :key="idx">
                    <div class="carouselList">
                        <div
                            class="carouselItem"
                            v-for="(iitem, i) in item"
                            :key="i"
                            @click="findDetail(iitem)"
                        >
                            <img :src="iitem.image" class="carouselBG" />
                            <div class="carouselFont">
                                {{ iitem.description }}
                            </div>
                        </div>
                    </div>
                </div>
            </a-carousel>
        </div>
        <div style="height: 72px"></div>
    </div>
</template>
<script>
import CultivationOfTalentsTop from "@/components/CultivationOfTalentsTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "EmployeeTraining",
    components: {
        CultivationOfTalentsTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryNewsList",
            infoList: [],
            topList: [],
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        findDetail(item) {
            this.$router.push({
                name: "CultivationOfTalentsDetail",
                params: item,
            });
        },
        leftClick() {
            this.$refs.carouselDom.prev();
        },
        rightClick() {
            this.$refs.carouselDom.next();
        },
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 290,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    let itemArr = [];
                    res.result.records.forEach((item) => {
                        if (item.showTop == 1) {
                            that.topList.push(item);
                        } else {
                            itemArr.push(item);
                        }
                    });
                    let newItemArr = [];
                    let newArr = [];
                    for (let i = 0; i < itemArr.length; i++) {
                        newArr.push(itemArr[i]);
                        if (newArr.length == 3) {
                            newItemArr.push(newArr);
                            newArr = [];
                        }
                    }
                    itemArr.length % 3 == 0 ? "" : newItemArr.push(newArr);
                    that.infoList = newItemArr;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.omit {
    white-space: nowrap; /*一行显示*/
    overflow: hidden; /*超出部分隐藏*/
    text-overflow: ellipsis; /*用...代替超出部分*/
}
.beyondOne {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.imgAdaptive {
    width: 100%;
    height: 100%;
}
.bgSet {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.middle {
    .typeArea();
    margin-bottom: 80px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .middleItem {
        cursor: pointer;
        width: calc(50% - 15px);
        .itemImg {
            height: 300px;
            background: black;
        }
        .itemTitle {
            .omit();
            margin-top: 20px;
            font-family: "优设标题黑";
            font-size: 32px;
            letter-spacing: 0px;
            color: #333333;
        }
        .itemContent {
            .beyondOne();
            font-size: 18px;
            letter-spacing: 0px;
            color: #333333;
        }
    }
}
</style>
<style lang="less">
.carouselDiv {
    width: 1100px;
    margin-bottom: 72px;
    margin: 0 auto;
    position: relative;
    .carouselDivLeft {
        cursor: pointer;
        position: absolute;
        left: 35px;
        z-index: 1;
        top: 120px;
    }
    .carouselDivRight {
        cursor: pointer;
        position: absolute;
        right: 35px;
        z-index: 1;
        top: 120px;
    }
    .ant-carousel .slick-dots li {
        margin: 0 6px;
    }
    .ant-carousel .slick-dots li button {
        width: 5px;
        height: 6px;
        background-color: black;
    }
    .ant-carousel .slick-dots .slick-active button {
        width: 17px;
        height: 6px;
        background-color: #0052d9;
    }
    .ant-carousel .slick-dots-bottom {
        bottom: 0;
    }
    .carouselList {
        margin-bottom: 64px;
        display: flex;
        justify-content: space-between;
        .carouselItem {
            .carouselBG {
                width: 353px;
                height: 240px;
                background-image: linear-gradient(
                    155deg,
                    #26314c 0%,
                    #000000 100%
                );
            }
            .carouselFont {
                margin-top: 20px;
                width: 323px;
                font-size: 18px;
                letter-spacing: 0px;
                color: #333333;
            }
        }
    }
}
</style>
